import axios from "axios";
import { getAttribution, getGaClientId, track } from "./analytics";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });

// ---------------- Auth ----------------
export const exchangeSession = async (session_id) => {
  const { data } = await http.post("/auth/session", { session_id, attribution: getAttribution() || undefined });
  return data;
};

export const getMe = async () => {
  const { data } = await http.get("/auth/me");
  return data;
};

export const logout = async () => {
  const { data } = await http.post("/auth/logout");
  return data;
};

export const registerUser = async (payload) => {
  const { data } = await http.post("/auth/register", { ...payload, attribution: getAttribution() || undefined });
  track("sign_up", { method: "email" });
  return data;
};

export const loginUser = async (payload) => {
  const { data } = await http.post("/auth/login", payload);
  track("login", { method: "email" });
  return data;
};

// ---------------- Companies ----------------
export const listCompanies = async () => {
  const { data } = await http.get("/companies");
  return data;
};

export const createCompany = async (payload) => {
  const { data } = await http.post("/companies", payload);
  return data;
};

export const updateCompany = async (id, payload) => {
  const { data } = await http.put(`/companies/${id}`, payload);
  return data;
};

export const deleteCompany = async (id) => {
  const { data } = await http.delete(`/companies/${id}`);
  return data;
};

// ---------------- AI ----------------
export const interpretQuote = async (messages, company, companyId) => {
  const { data } = await http.post("/quotes/interpret", { messages, company, company_id: companyId || undefined });
  return data;
};

// ---------------- Catálogo ----------------
export const listCatalog = async (companyId, params = {}) => (await http.get(`/companies/${companyId}/catalog`, { params })).data;
export const createCatalogItem = async (companyId, payload) => (await http.post(`/companies/${companyId}/catalog`, payload)).data;
export const updateCatalogItem = async (companyId, id, payload) => (await http.put(`/companies/${companyId}/catalog/${id}`, payload)).data;
export const deleteCatalogItem = async (companyId, id) => (await http.delete(`/companies/${companyId}/catalog/${id}`)).data;
export const duplicateCatalogItem = async (companyId, id) => (await http.post(`/companies/${companyId}/catalog/${id}/duplicate`)).data;
export const reorderCatalog = async (companyId, ids) => (await http.post(`/companies/${companyId}/catalog/reorder`, { ids })).data;
export const suggestCatalogDescription = async (companyId, payload) => (await http.post(`/companies/${companyId}/catalog/suggest-description`, payload)).data;
export const importCatalogPreview = async (companyId, file) => {
  const fd = new FormData(); fd.append("file", file);
  return (await http.post(`/companies/${companyId}/catalog/import/preview`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 180000 })).data;
};
export const importCatalogCommit = async (companyId, items) => (await http.post(`/companies/${companyId}/catalog/import/commit`, { items })).data;

export const editQuote = async (payload) => {
  const { data } = await http.post("/quotes/edit", payload);
  return data;
};

// ---------------- Quotes ----------------
export const setUserFlag = async (key, value = true) => (await http.post("/me/flags", { key, value })).data;
export const sendExpectation = async (text) => (await http.post("/feedback/expectation", { text })).data;

export const renderQuotePdf = async (payload) => {
  const { data } = await http.post("/quotes/pdf", payload, { responseType: "blob", timeout: 90000 });
  return data;
};

export const listQuotes = async (companyId) => {
  const { data } = await http.get("/quotes", { params: { company_id: companyId } });
  return data;
};

export const getQuote = async (id) => {
  const { data } = await http.get(`/quotes/${id}`);
  return data;
};

export const saveQuote = async (payload) => {
  const { data } = await http.post("/quotes", payload);
  return data;
};

export const updateQuote = async (id, payload) => {
  const { data } = await http.put(`/quotes/${id}`, payload);
  return data;
};

export const deleteQuote = async (id) => {
  const { data } = await http.delete(`/quotes/${id}`);
  return data;
};

// ---------------- Plan + Payments ----------------
export const getMyPlan = async () => {
  const { data } = await http.get("/me/plan");
  return data;
};

export const createCheckout = async (lookup_key) => {
  const { data } = await http.post("/payments/checkout", { lookup_key, origin_url: window.location.origin, ga_client_id: getGaClientId() || undefined });
  track("begin_checkout", { lookup_key });
  return data;
};

export const paymentStatus = async (sessionId) => {
  const { data } = await http.get(`/payments/status/${sessionId}`);
  return data;
};

export const cancelSubscription = async ({ reasons, comment }) => {
  const { data } = await http.post("/payments/cancel", { reasons, comment });
  return data;
};

export const resumeSubscription = async () => {
  const { data } = await http.post("/payments/resume");
  return data;
};

export const changePlan = async (lookup_key) => {
  const { data } = await http.post("/payments/change-plan", { lookup_key });
  return data;
};

// ---------------- WhatsApp (per user) ----------------
export const whatsappLink = async (payload) => {
  const { data } = await http.post("/whatsapp/link", payload);
  return data;
};

export const whatsappStatus = async () => {
  const { data } = await http.get("/whatsapp/status");
  return data;
};

export const whatsappInvite = async (phone) => {
  const { data } = await http.post("/whatsapp/invite", { phone });
  return data;
};
